















































import Group from '@/types/Group.interface'
import Person from '@/types/Person.interface'
import PersonsAutocomplete from '@/components/PersonsAutoComplete.vue'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    components: { PersonsAutocomplete },
    props: {
        //  The group we are editing/creating
        group: {
            type: Object as PropType<Group>,
            required: true
        },
        //  Disables the form when true
        loading: {
            type: Boolean,
            default: false
        },
        //  The maxium horizontal width of the form
        maxWidth: {
            type: String,
            default: '400px'
        }
    },
    data() {
        return {
            //  The dynamic group description label
            optional: 'Group Description (optional)',
            //  The temporary clone of the group we're editing
            temp: null
        }
    },
    mounted() {
        //  Clone the group we're editing, so we can revert changes if needed
        this.temp = window._.cloneDeep(this.group)

        //  Focus on the group name input (we use setTimeout to avoid animation errors caused by focusing an element)
        setTimeout(() => {
            this.$refs.groupName.focus()
        }, 500)
    },
    methods: {
        memberCount(group: Group): number {
            if (!group.persons) return 0

            return group.persons.length
        },
        onPersonRemoved(person: Person): void {
            //  Remove the person from the group
            this.temp.persons.remove(person)
        },
        onPersonSelected(person: Person): void {
            //  If temp does NOT have persons, then make it an array
            this.temp.persons = this.temp.persons || []

            //  Check if the person is already in the group
            const inGroup = this.temp.persons.find((x) => x.id === person.id)

            //  If the person is already in the group, do nothing (Should we pop a message to the user here?)
            if (inGroup) return

            //  Else, add the person to the group
            this.temp.persons.push(person)
        },
        async submit(group: Group): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Clone our group so we don't modify visually what is happening
            const temp = window._.cloneDeep(group)

            //  Merge changes from 'persons' into 'persons_ids'
            temp.persons_ids = temp.persons.map((x: Person) => x.id)

            //  Remove unneeded 'persons' (to make payload smaller)
            delete temp.persons

            //  Submit the edited/created group to the parent
            this.$emit('submit', temp)
        }
    }
})
